import * as React from "react";

/**
 * Provides a means to call async functions in an effect.
 *
 * This hook is not needed if you are not going to await anything.
 * In that case it would be best to use the React.useEffect hook directly.
 *
 * @param callback function to call when the effect is run
 * @param dependencies array of dependencies that will determine when the effect is run.
 *
 * Passing nothing will
 * result in the effect being run on every render.
 *
 * Passing an empty array will effectively result in the
 * effect being run only on mount of the component.
 */
export const useAsyncEffect = (
    callback: (...args) => Promise<any>,
    dependencies?: any[]
) => {
    React.useEffect(() => {
        const fn = async () => {
            await callback();
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};
